import React from "react"
import { Link } from "react-router-dom"
import { FaAngleDoubleRight } from "react-icons/all"

// data
import audios from "../../data/audios"

// components
import AudioCard from "../audioCard"

let featured_beats = audios.filter((o) => o.featured === true)

const Beats = () => {
  return (
    <section className="beats" id="beats">
      <div className="container">
        <header>
          <h1 className="main-heading">Beats</h1>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque
            auctor pulvinar urna eget. Libero porttitor lectus orci odio.
          </p>
        </header>
        <div className="showcase">
          {featured_beats.slice(0, 5).map((audio, index) => (
            <AudioCard
              key={index}
              id={audio.id}
              title={audio.title}
              descr={audio.descr}
              src={audio.src}
              type={audio.type}
            />
          ))}
        </div>
        <div className="btns">
          <Link to="beats">
            See More <FaAngleDoubleRight className="icon" />
          </Link>
        </div>
      </div>
    </section>
  )
}

export default Beats
